import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    CheckBox,
    DataSelect,
    TextList,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffCitiesEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formProvinceId, setFormProvinceId] = useState(null);
    const [formProvinceIdOptions, setFormProvinceIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-cities-edit/select-data/province-id').then((response) => {
            setFormProvinceIdOptions(response.data);
        });
    }, []);
    const [formIsActive, setFormIsActive] = useState(false);
    const [formOtherNames, setFormOtherNames] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-cities-edit/save-data', {
            id: allProps['taroff-cities-id'],
            province_id: formProvinceId,
            is_active: formIsActive,
            other_names: formOtherNames,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-cities-edit/form-data', {
            id: allProps['taroff-cities-id'],
        }).then((response) => {
            setFormProvinceId(response.data.province_id);
            setFormIsActive(response.data.is_active);
            setFormOtherNames(response.data.other_names);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'استان'}
                            options={formProvinceIdOptions}
                            value={formProvinceId}
                            onChange={setFormProvinceId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox label={'فعال'} value={formIsActive} onChange={setFormIsActive} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextList
                            label={'سایر نام ها'}
                            value={formOtherNames}
                            onChange={setFormOtherNames}
                        />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
